export default __webpack_public_path__ + "static/media/stomach-diseases.c84f3179.jpg";